module.exports = __webpack_public_path__ + "static/media/03d.8d2c0b2d.svg";